import { DisplayType } from '../constants/displayType';

export const flipDisplay = (display: DisplayType): DisplayType =>
  display === DisplayType.map ? DisplayType.grid : DisplayType.map;
import { DisplayType } from '../constants/displayType';

export const flipDisplay = (display: DisplayType): DisplayType =>
  display === DisplayType.map ? DisplayType.grid : DisplayType.map;
